module.exports = __webpack_public_path__ + "img/product17.f59cd7f6.png";